export default {
  合同管理信息列表: "Contract Management List",
  申请合同审查: "Apply for Contract Review",
  合同审查申请: "Contract Review Application",
  合同基础信息: "Basic Contract Information",
  供应商编号: "Supplier Code",
  请选择供应商: "Please select supplier",
  供应商名称中文: "Supplier Name (Chinese)",
  供应商名称英文: "Supplier Name (English)",
  自动带出: "Auto-populated",
  合同名称: "Contract Name",
  请输入合同名称: "Please enter contract name",
  请输入: "Please enter",
  合同编号: "Contract Number",
  请输入合同编号: "Please enter contract number",
  合同总金额币种: "Total Contract Amount / Currency",
  请输入合同金额: "Please enter contract amount",
  请选择币种: "Please select currency",
  合同有效期: "Contract Validity Period",
  请选择合同有效期: "Please select contract validity period",
  合同主要内容: "Main Contract Content",
  请输入合同主要内容: "Please enter main contract content",
  合同文件: "Contract File",
  相关文件: "Related Files",
  合同文件信息: "Contract File Information",
  双方已签署合同: "Signed Contracts by Both Parties",
  合同相关附件: "Contract Related Attachments",
  KMS合同文件编号: "KMS Contract File Number",
  请输入KMS合同文件编号: "Please enter KMS contract file number",
  申请人信息: "Applicant Information",
  申请人: "Applicant",
  请选择申请人: "Please select applicant",
  部门: "Department",
  部门主管: "Department Manager",
  工厂: "Factory",
  请选择工厂: "Please select factory",
  合同来源: "Contract Source",
  请选择合同来源: "Please select contract source",
  已批准采购申请表编号: "Approved Purchase Application No.",
  附件上传: "Attachment Upload",
  合同审查信息: "Contract Review Information",
  合同类别: "Contract Category",
  请选择合同类别: "Please select contract category",
  合同子类别: "Contract Subcategory",
  请选择合同子类别: "Please select contract subcategory",
  合同描述: "Contract Description",
  请输入合同描述: "Please enter contract description",
  合同审查项: "Contract Review Items",
  合同检查项: "Contract Check Items",
  公司标准: "Company Standard",
  实际: "Actual",
  请选择: "Please select",
  请输入备注: "Please enter remarks",
  合同上传方: "Contract Uploader",
  流程状态: "Process Status",
  当前节点: "Current Node",
  供应商: "Supplier",
  供应商名称: "Supplier Name",
  用户部门: "User Department",
  操作: "Action",
  编辑: "Edit",
  查看: "View",
  重新提交: "Resubmit",
  删除: "Delete",
  草稿: "Draft",
  已驳回: "Rejected",
  审批中: "Under Review",
  已存档: "Archived",
  暂存: "Save as Draft",
  提交: "Submit",
  关闭: "Close",
  审批成功: "Approval Successful",
  暂存已提交: "Draft saved successfully",
  申请已提交: "Application submitted successfully",
  提交成功: "Submitted successfully",
  供应商提供: "Provided by Supplier",
  删除成功: "Deleted successfully",
  BF合同模版: "BF Contract Template",
  常规服务年度合同更新与同一供应商续签:
    "Annual Contract Renewal with Same Supplier",
  不能提供合同但有采购订单必须说明理由:
    "No Contract but Purchase Order (Reason Required)",
  "未上传合同：查询不到目标文件，请先上传合同":
    "Contract not uploaded: Target file not found, please upload the contract first",
  "合同正在审核，请耐心等待": "Contract is under review, please wait patiently",
  合同审核失败: "Contract audit failed",
  查看AI审核结果: "View AI audit results",
  合同审核: "Contract Audit",
  AI审核: "AI Audit",
  审查结果: "Review Findings",
  高: "High",
  中: "Medium",
  低: "Low",
  暂无: "None",
  检测结果为空: "No detection results found",
  存在问题: "Issues Identified",
  建议修改内容: "Suggested Revisions",
  风险程度: "Risk Level",
  检测正常: "Detection Passed",
};
